import React from 'react';

import './index.scss';

interface IKeyUpdatesContentsProps {
  data?: string;
}

const KeyUpdatesContents: React.FC<IKeyUpdatesContentsProps> = (props) => {
  const { data = '' } = props;
  return (
    <>
      {!data && <div className="key-updates-no-data">No information.</div>}
      {data && (
        <span
          className="gp-wang-edit-content gp-word-break-word gp-inital-list-style dbg-edit-text dbg-rich-text-editor-content"
          dangerouslySetInnerHTML={{ __html: data || '-' }}
        ></span>
      )}
    </>
  );
};

export default React.memo(KeyUpdatesContents);
